export var DataFieldType;
(function (DataFieldType) {
    DataFieldType[DataFieldType["String"] = 0] = "String";
    DataFieldType[DataFieldType["Boolean"] = 1] = "Boolean";
    DataFieldType[DataFieldType["Int64"] = 2] = "Int64";
    DataFieldType[DataFieldType["Double"] = 3] = "Double";
    DataFieldType[DataFieldType["Guid"] = 4] = "Guid";
})(DataFieldType || (DataFieldType = {}));
//# sourceMappingURL=DataFieldType.js.map